<!--运行管理系统主文件-->
<template>
  <div class="policy_system_main">
    <div class="banner">
      <!--系统标题-->
      <sys_logo name="物联网监测管理"></sys_logo>
      <!--当前用户-->
      <sys_cur_user></sys_cur_user>

      <!--系统主菜单-->

      <!--临时隐藏-->
      <!--<el-menu :default-active="activeIndex" router
               class="el-menu-top" mode="horizontal" background-color="#4079C5" text-color="#fff"
               active-text-color="#fff">
        <el-menu-item v-for="(item,index) in navigation" :route=item.path :index=item.path :key="path">
          {{ item.name }}
        </el-menu-item>
      </el-menu>-->
    </div>

    <!--主菜单路由占位-->
    <router-view
      style="background-color: #EFF0F3; width: 100%;height: calc(100% - 60px);"
    ></router-view>
  </div>
</template>

<script>
import Sys_logo from "../../../../sub_systems/sub_system_common_components/sys_logo";
import Sys_cur_user from "../../../../sub_systems/sub_system_common_components/sys_cur_user";
export default {
  name: "policy_system_main",
  components: { Sys_cur_user, Sys_logo },
  computed: {},
  data() {
    return {
      navigation: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /*添加主菜单权限*/
    init() {
      this.navigation = [{ path: "/assetService", name: "首页" }];
    }

    /**
     * 根据路由激活当前菜单index
     * @param path
     */
    // get_activeIndex_by_path(path){

    //   if (path.startsWith("/policyNews/index")) {
    //     return "/agroService"
    //   }

    // }
  }
};
</script>

<style lang="scss">
.policy_system_main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 600;

  position: absolute;
  left: 0;
  top: 0;

  .banner {
    width: 100%;
    height: 60px;
    background-color: #00955b;
  }

  .el-menu-top {
    padding-left: 250px;
    display: flex;
    justify-content: left;

    .el-menu-item {
      font-size: 16px;
      border-bottom: none !important;
    }
    .el-menu-item.is-active {
      border-bottom: none !important;
      &:before {
        content: " ";
        background-color: #fff;
        height: 2px;
        width: 48px;
        display: block;
        position: absolute;
        bottom: 2px;
        left: 50%;
        margin-left: -24px;
        border-bottom: none !important;
      }
    }
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/wlwyzt_asset_main.vue